import React from 'react';
import { Dialog, DialogContent, DialogActions, Button, Box, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import BlockIcon from '@mui/icons-material/Block';
import { getPartnerStatusMeta, PARTNER_STATUS_VALUES } from '../../utils/partnerStatus';

const PartnerStatusChangeDialog = ({
  open,
  partnerName,
  nextStatus,
  submitting = false,
  onClose,
  onConfirm,
}) => {
  const isApprove = nextStatus === PARTNER_STATUS_VALUES.LIVE;
  const statusMeta = getPartnerStatusMeta(nextStatus);

  return (
    <Dialog
      open={open}
      onClose={submitting ? undefined : onClose}
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 2,
          textAlign: 'center',
          maxWidth: 400,
          width: '100%',
        },
      }}
    >
      <DialogContent sx={{ pb: 1, pt: 1 }}>
        <Box
          sx={{
            width: 60,
            height: 60,
            borderRadius: '50%',
            bgcolor: isApprove ? 'rgba(46, 125, 50, 0.12)' : 'rgba(211, 47, 47, 0.12)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 2,
          }}
        >
          {isApprove ? (
            <CheckCircleOutlineIcon sx={{ fontSize: 32, color: '#2e7d32' }} />
          ) : (
            <BlockIcon sx={{ fontSize: 32, color: '#d32f2f' }} />
          )}
        </Box>
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
          Mark partner as {statusMeta.label.toLowerCase()}?
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
          {isApprove ? (
            <>
              Approve{' '}
              <Box component="span" sx={{ fontWeight: 600, color: 'text.primary' }}>
                {partnerName || 'this partner'}
              </Box>{' '}
              and set their organization status to live.
            </>
          ) : (
            <>
              Reject{' '}
              <Box component="span" sx={{ fontWeight: 600, color: 'text.primary' }}>
                {partnerName || 'this partner'}
              </Box>
              ? Their website submission will be marked as rejected.
            </>
          )}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', gap: 2, pb: 1, pt: 2 }}>
        <Button
          variant="outlined"
          onClick={onClose}
          disabled={submitting}
          sx={{ minWidth: 100, textTransform: 'none' }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color={isApprove ? 'success' : 'error'}
          onClick={onConfirm}
          disabled={submitting}
          sx={{ minWidth: 100, textTransform: 'none' }}
        >
          {submitting ? 'Updating…' : isApprove ? 'Approve' : 'Reject'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PartnerStatusChangeDialog;
